import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
import { srConfig, email } from '@config';
import sr from '@utils/sr';
import { usePrefersReducedMotion } from '@hooks';

const StyledContactSection = styled.section`
  max-width: 600px;
  min-height: 100vh;
  margin: 0 auto 100px;
  text-align: center;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center; /* ✅ Add this line */

  @media (max-width: 768px) {
    margin: 0 auto 50px;
  }

  .overline {
    display: block;
    margin-bottom: 20px;
    color: var(--green);
    font-family: var(--font-mono);
    font-size: var(--fz-md);
    font-weight: 400;

    &:before {
      bottom: 0;
      font-size: var(--fz-sm);
    }

    &:after {
      display: none;
    }
  }

  .title {
    font-size: clamp(40px, 5vw, 60px);
  }

  .email-link {
    ${({ theme }) => theme.mixins.bigButton};
    margin-top: 50px;
  }
`;

const Contact = () => {
  const revealContainer = useRef(null);
  const prefersReducedMotion = usePrefersReducedMotion();

  useEffect(() => {
    if (prefersReducedMotion) {
      return;
    }

    sr.reveal(revealContainer.current, srConfig());
  }, []);

  return (
    <StyledContactSection id="contact" ref={revealContainer}>
      <h2 className="numbered-heading overline">What's next?</h2>

      <h2 className="title">Let's ignite ambitions</h2>

      <p>
        Stuur een postduif, mail naar <a href="mailto:sten@flii.nl">sten@flii.nl</a> of <a href="https://maps.app.goo.gl/81u3kVTVq13E6AiB6">kom langs op kantoor</a> in Amstelveen.
      </p>

      <a className="email-link" href={`mailto:${email}`}>
        Contact
      </a>
    </StyledContactSection>
  );
};

export default Contact;
